import { render, staticRenderFns } from "./MemberCrud.vue?vue&type=template&id=9a606cb2&scoped=true&"
import script from "./MemberCrud.vue?vue&type=script&lang=js&"
export * from "./MemberCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a606cb2",
  null
  
)

export default component.exports